import React from 'react';

interface DashboardIconProps {
  className?: string;
  size?: number;
}

/**
 * Dashboard icon component
 * Displays the dashboard icon with a blue background, panel grid, and pie chart
 */
export const DashboardIcon: React.FC<DashboardIconProps> = ({
  className = "",
  size,
}) => {
  const sizeProps = size ? { width: size, height: size } : {};

  return (
    <svg
      {...sizeProps}
      className={className}
      viewBox="0 0 512 512"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Cyan-to-blue gradient for panel areas */}
        <linearGradient
          id="dashboard-gradient-panels"
          x1="62.4375"
          y1="225.11914"
          x2="449.5625"
          y2="225.11914"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#00fdff" stopOpacity="1" />
          <stop offset="1" stopColor="#22afff" stopOpacity="1" />
        </linearGradient>

        {/* Yellow-to-orange gradient for pie circle */}
        <linearGradient
          id="dashboard-gradient-circle"
          x1="245.51792"
          y1="489.33084"
          x2="456.93613"
          y2="489.33084"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffdb00" stopOpacity="1" />
          <stop offset="1" stopColor="#e37f00" stopOpacity="1" />
        </linearGradient>

        {/* Red gradient for pie slice */}
        <linearGradient
          id="dashboard-gradient-slice"
          x1="-489.33084"
          y1="456.93613"
          x2="-489.33084"
          y2="351.22702"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#da0000" stopOpacity="1" />
          <stop offset="1" stopColor="#ff4545" stopOpacity="1" />
        </linearGradient>
      </defs>

      {/* Background rectangle */}
      <rect
        fill="#1566e5"
        width="458.30756"
        height="371.52167"
        x="26.846222"
        y="38.029778"
      />

      {/* Panel areas: top bar, bottom-left, bottom-right */}
      <path
        fill="url(#dashboard-gradient-panels)"
        d="M 62.4375 73.109375 L 62.4375 213.52734 L 449.5625 213.52734 L 449.5625 73.109375 L 62.4375 73.109375 z M 62.4375 236.71094 L 62.4375 377.12891 L 242.35938 377.12891 L 242.35938 236.71094 L 62.4375 236.71094 z M 269.64062 236.71094 L 269.64062 377.12891 L 449.5625 377.12891 L 449.5625 236.71094 L 269.64062 236.71094 z"
      />

      {/* Pie chart */}
      <g transform="translate(45.867902,-138.26059)">
        {/* Full circle base */}
        <circle
          fill="url(#dashboard-gradient-circle)"
          cx="351.22702"
          cy="489.33084"
          r="105.7091"
        />
        {/* Highlighted slice */}
        <path
          fill="url(#dashboard-gradient-slice)"
          d="m -383.62174,351.22702 a 105.7091,105.7091 0 0 1 -55.74703,93.15688 105.7091,105.7091 0 0 1 -108.44328,-5.09802 l 58.48121,-88.05886 z"
          transform="rotate(-90)"
        />
      </g>
    </svg>
  );
};

export default DashboardIcon;
